<template>
  <nav
    class="navbar"
    :class="[
      { 'navbar-expand-md': expand },
      { 'navbar-transparent': transparent },
      { [`bg-${type}`]: type }
    ]"
  >
    <div class="container-fluid">
      <slot name="brand">
        <router-link
          :to="$route.path"
          class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block content-header-title float-left pr-3"
        >
          {{ $t($route.name) }}
        </router-link>
      </slot>
      <div
        class="breadcrumb-wrapper"
        v-if="
          $route.name !== 'dashboard' || $route.name !== 'ecommerce_companies'
        "
      >
        <!-- <b-breadcrumb class="mt-3">
          <b-breadcrumb-item to="/">
            <i class="fas fa-home"></i>
          </b-breadcrumb-item>
          <b-breadcrumb-item
            v-for="item in $route.meta.breadcrumb"
            :key="item.text"
            :active="item.active"
            :to="item.to"
            @click="item.back === 'show_product' ? $router.back() : null"
          >
            <span class="text-white">{{ $t(item.text) }}</span>
          </b-breadcrumb-item>
        </b-breadcrumb> -->
      </div>
      <navbar-toggle-button
        v-if="showToggleButton"
        :toggled="toggled"
        :target="contentId"
        @click.native.stop="toggled = !toggled"
      >
        <i class="ri-menu-fill table-text"></i>
      </navbar-toggle-button>

      <div
        class="collapse navbar-collapse"
        :class="{ show: toggled }"
        :id="contentId"
        v-click-outside="closeMenu"
      >
        <slot :close-menu="closeMenu"></slot>
      </div>
    </div>
  </nav>
</template>
<script>
import NavbarToggleButton from "./NavbarToggleButton";

export default {
  name: "base-nav",
  components: {
    NavbarToggleButton
  },
  props: {
    type: {
      type: String,
      default: "",
      description: "Navbar type (e.g default, primary etc)"
    },
    title: {
      type: String,
      default: "",
      description: "Title of navbar"
    },
    contentId: {
      type: [String, Number],
      default: Math.random().toString(),
      description:
        "Explicit id for the menu. By default it's a generated random number"
    },
    containerClasses: {
      type: [String, Object, Array],
      default: "container-fluid"
    },
    transparent: {
      type: Boolean,
      default: false,
      description: "Whether navbar is transparent"
    },
    expand: {
      type: Boolean,
      default: false,
      description: "Whether navbar should contain `navbar-expand-lg` class"
    },
    showToggleButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      toggled: false
    };
  },
  methods: {
    closeMenu() {
      this.toggled = false;
    }
  }
};
</script>
<style scope>
.breadcrumb {
  background-color: transparent;
}
.breadcrumb-item.active {
  color: #c9c9c9;
}
.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #fff;
  content: "/";
}
.breadcrumb-item a {
  color: #fff;
  text-decoration: none;
  background-color: transparent;
}

.content-header-title {
  border-right: 1px solid #fff;
}
</style>
